import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from './store-read-settings/store-read-settings.util';
import {
    convertFormatSettingsToResource,
    convertFormatSettingsToModel
} from './format-read-settings/format-read-settings.util';
import { OrcCopySource } from 'app/model/pipeline/copysource/orc.source';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OrcCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class OrcCopySourceAdapter extends CopySourceAdapter<OrcCopySource, Model.OrcSource> {
    protected override async _toResource(copySource: OrcCopySource): Promise<Model.OrcSource> {
        const result: Model.AvroSource = this.getCommonCopySourceProperties(copySource, OrcCopySource.MODEL.name);

        await convertStoreSettingsToResource(copySource.storeSettings, result, this.context);
        await convertFormatSettingsToResource(copySource.formatSettings, result, this.context);

        return result;
    }

    protected override async _toModel(source: Model.OrcSource, copyActivity: CopyActivity): Promise<OrcCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            OrcCopySource.MODEL,
            source,
            copyActivity
        ) as OrcCopySource;

        await convertStoreSettingsToModel(source.storeSettings, result, this.context);
        await convertFormatSettingsToModel(source.formatSettings, result, this.context);
        return result;
    }
}
